// extracted by mini-css-extract-plugin
export default {"root":"App_root__nZZtU","headerContainer":"App_headerContainer__wmV6R","bodyContainer":"App_bodyContainer__3+gLL"};